__turbopack_context__.v({
  "app-chip": "chip-module__rQyKma__app-chip",
  "bg-danger-100": "chip-module__rQyKma__bg-danger-100",
  "bg-warning-100": "chip-module__rQyKma__bg-warning-100",
  "pointer": "chip-module__rQyKma__pointer",
  "text-danger-200": "chip-module__rQyKma__text-danger-200",
  "text-warning-200": "chip-module__rQyKma__text-warning-200",
});
